import styled from 'styled-components';

export const LayoutWrapper = styled.div`
    display: flex;
    height: 100vh;
    flex-direction: column;
    background-color: ${({theme}) => theme.palette.layout.main};  
`;

export const ContentWrapper = styled.div`
    display: flex;
    flex: 1;
`;

export const MainContent = styled.div<{ $sidebarOpen: boolean; $isMobile: boolean }>`
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    padding: 20px;
    
    min-height: 0;

    overflow-y: auto;
    transition: margin-left 0.3s;
    
    @media (max-width: 959px) {
        padding: 16px;
    }
    @media (max-width: 500px) {
        padding: 8px;
    } 
    @media (max-width: 400px) {
        padding: 4px;
    }
`;